export enum GameGenres {
  adventure = 'adventure',
  survival = 'survival',
  popular = 'popular',
  fast = 'fast',
  mostPopular = 'mostPopular',
  infiniteRun = 'infiniteRun',
  womenFavorite = 'womenFavorite',
  platformer = 'platformer',
  addictive = 'addictive',
  hypercasual = 'hypercasual',
  game3d = '3DGames',
  fastPace = 'fastPace'
}

export enum GameTypes {
  game2d = 'game2d',
  game3d = 'game3d'
}

export enum GameKeys {
  fallingAsteroids = 'fallingAsteroids',
  shoppingBirds = 'shoppingBirds',
}
